import { ENABLE_MENU_MANAGEMENT, HIDE_INVOICES, HIDE_MENU_MAPPING } from 'scopes/cubohUserMeta';

export type UserMeta = { [key: string]: boolean | string };
export type ScopeDetails = {
  isInternalUser: boolean;
  cubohIsParentCompanyUser: boolean;
  cubohUserMeta: UserMeta;
  isUserCubohOnly: boolean;
  companies?: {
    [key: string]: { [resource: string]: { type: string; use_mm_endpoint: boolean } };
  } | null;
};

export const hasUserMeta = (userMeta: UserMeta, requiredMeta: string) => {
  if (typeof userMeta[requiredMeta] === 'string') {
    return userMeta[requiredMeta].toLowerCase() === 'true';
  }

  return !!userMeta[requiredMeta];
};

export const canSeeInvoices = (scopeDetails: ScopeDetails) =>
  scopeDetails.isUserCubohOnly && !hasUserMeta(scopeDetails.cubohUserMeta, HIDE_INVOICES);

export const canSeeMenuManagement = (scopeDetails: ScopeDetails) => {
  if (!scopeDetails.isUserCubohOnly) {
    return true;
  }

  return (
    scopeDetails.cubohIsParentCompanyUser ||
    hasUserMeta(scopeDetails.cubohUserMeta, ENABLE_MENU_MANAGEMENT)
  );
};

export const canSeeMenuMapping = (scopeDetails: ScopeDetails) => {
  const { companies } = scopeDetails;
  if (!companies) return false;

  const hasShowMeta = !hasUserMeta(scopeDetails.cubohUserMeta, HIDE_MENU_MAPPING);

  const companyDetailList = Object.values(companies);
  const someCompanyHasPos = companyDetailList.some(
    company => !!company?.resource?.type || (!!company?.pos_active && !!company?.point_of_sale),
  );
  const allCompaniesHaveShooter = companyDetailList.every(
    company => !!company?.resource?.use_mm_endpoint,
  );
  return (
    scopeDetails.isUserCubohOnly && hasShowMeta && someCompanyHasPos && !allCompaniesHaveShooter
  );
};
